import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { IOfflineService } from '../interfaces/offline-service.interface';
import { PlanData } from '@docma-mm-core/plan/plan';

@Injectable({
  providedIn: 'root'
})
export class WebOfflineService implements IOfflineService {
    constructor() {
    }
  
  async getData(request: HttpRequest<unknown>): Promise<any> {
    
  }

  async checkNeedsUpdate(id:string, relativePath: string, date: Date): Promise<boolean> {
    return false;        
  }

  saveDataByFolderPath(data: any, folderName: string, uid: string):Promise<any>{
    return null;
  }
  saveDataByUrl(request: HttpRequest<unknown>, data: any):Promise<any>{
    return null;
  }   

  getAttachment(attachmentUid: string, fileName: string): Promise<Blob> {
    return null;
  }

  unzipAndSave(data: Blob, planId: string, onlySaveBaseTiles: boolean): Promise<any> {
    return null;
  }

  async isPlanDownloaded(planId:string): Promise<boolean> {
    return false;
  }

  saveAttachment(data: Blob, fileName: string): Promise<string>{
    return null;
  }

  downloadAttachment(attachmentId: number, attachmentUid: string, fileName: string, extendedContentDisposition: boolean, width: number, height: number, originalWithScribbles: boolean): Promise<string>{
    return null;
  }

  isAttachmentDownloaded(attachmentUid: string): Promise<boolean> {
    return null;
  }

  removeAttachment(attachmentUid: string): Promise<void> {
    return null;
  }

  removePlan(planId: string): Promise<boolean> {
    return null;
  }

  get currentProject(): any {
    return null;
  }
}